import styled, { css } from 'styled-components';
import { Button, Col, Tag } from 'antd';
import { Text } from '@/components/Typography';

export const CustomTitle = styled.h2`
	${({ theme }) => css`
		${{ ...theme.fonts.heading.md }}
	`}
`;

export const CustomText = styled(Text)`
	${({ theme }) => css`
		${{ ...theme.fonts.label.md }}
	`}
	align-items: center;
`;

export const CustomTableText = styled(Text)`
	${({ theme }) => css`
		${{ ...theme.fonts.body.sm }}
	`}
`;

export const ActionsInline = styled(Col)`
	display: none;
	@media (min-width: 1626px) {
		display: flex;
		justify-content: center;
	}
`;

export const ActionsMenu = styled(Col)`
	display: flex;
	@media (min-width: 1626px) {
		display: none;
	}
`;

export const CustomButton = styled.div`
	&:hover {
		span {
			color: ${({ theme }) => theme.palette.secondary.white};
		}
	}
`;

export const CustomTable = styled(Col)`
	.ant-table {
		border-radius: 10px;
		.ant-table-thead {
			.ant-table-cell:first-child {
				border-radius: 10px 0 0 0;
			}
			.ant-table-cell:last-child {
				border-radius: 0 10px 0 0;
			}
		}
		@media (max-width: 1389px) {
			.ant-table-tbody {
				.ant-table-cell {
					font-size: 12px !important;
				}
			}
			.ant-table-thead {
				.ant-table-cell {
					font-size: 13px !important;
				}
			}
		}
	}
`;

export const CustomButtonAntd = styled(Button)`
	display: flex;
	align-items: center;
	border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
	background: ${({ theme }) => theme.colors.primary};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
	font-weight: ${({ theme }) => theme.sizes.weights.regular};
	span:first-child {
		font-size: ${({ theme }) => theme.sizes.fonts.fs_lg};
		margin-top: 3px;
	}
`;

interface TagRiskProps {
	brightcolors?: number;
}

export const TagRisk = styled(Tag)<TagRiskProps>`
	border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
	width: 68%;
	max-width: 8rem;
	text-align: center;
	span {
		color: ${({ brightcolors }) => (brightcolors === 2 ? 'black' : 'white')};
	}
`;
